import type { GUIDScreenProps } from "./types";

function Party({ line1, line2 }: GUIDScreenProps) {
  return (
    <svg viewBox="0 0 800 340" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3024_5419)">
        <rect
          width="800"
          height="340"
          rx="54"
          fill="black"
          style={{ fill: "black", fillOpacity: 1 }}
        />
        <g clipPath="url(#clip1_3024_5419)">
          <rect
            width="800"
            height="340"
            fill="#080B2C"
            style={{ fill: "#080B2C", fillOpacity: 1 }}
          />
          <path
            d="M811.318 274.253L815.593 271.451L803.636 253.164L799.361 255.966L811.318 274.253Z"
            fill="#198428"
            style={{ fill: "#198428", fillOpacity: 1 }}
          />
          <g filter="url(#filter0_d_3024_5419)">
            <path
              d="M25.8738 110.025C26.1762 110.159 26.3128 110.514 26.1789 110.816L17.4086 130.613C17.2744 130.916 16.9201 131.053 16.6173 130.919L12.1289 128.925C11.8263 128.791 11.69 128.436 11.8241 128.133L20.5945 108.336C20.7288 108.034 21.0827 107.897 21.3854 108.032L25.8738 110.025Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M147.535 284.484C147.861 284.427 148.172 284.645 148.229 284.971L151.978 306.3C152.035 306.626 151.817 306.937 151.491 306.994L146.655 307.846C146.329 307.904 146.018 307.686 145.961 307.36L142.212 286.031L142.203 285.91C142.211 285.631 142.414 285.386 142.699 285.336L147.535 284.484Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M22.0311 319.734C22.1303 320.05 21.9547 320.387 21.6388 320.486L1.00155 326.973C0.685429 327.073 0.348051 326.897 0.248901 326.581L-1.22174 321.891C-1.32064 321.575 -1.1442 321.238 -0.828205 321.138L19.8091 314.651C20.125 314.552 20.4612 314.728 20.5605 315.044L22.0311 319.734Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M736.809 72.3703C736.909 72.6864 736.733 73.0237 736.417 73.1232L715.78 79.6102C715.464 79.7096 715.126 79.5334 715.027 79.2172L713.557 74.5274C713.458 74.2113 713.634 73.8745 713.95 73.7751L734.587 67.2881C734.903 67.1891 735.24 67.3646 735.339 67.6805L736.809 72.3703Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M305.806 278.167C305.905 278.483 305.729 278.821 305.413 278.92L284.776 285.407C284.46 285.506 284.122 285.33 284.023 285.014L282.553 280.324C282.454 280.008 282.63 279.671 282.946 279.572L303.583 273.085C303.899 272.986 304.236 273.162 304.335 273.477L305.806 278.167Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M601.739 50.2101C601.462 50.3917 601.09 50.3146 600.909 50.0375L589.061 31.9176C588.88 31.6403 588.958 31.2681 589.235 31.0865L593.343 28.3944C593.62 28.213 593.991 28.2905 594.172 28.5675L606.02 46.6875C606.201 46.9647 606.123 47.3364 605.847 47.518L601.739 50.2101Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M638.976 294.709C638.654 294.628 638.46 294.303 638.54 293.982L643.802 272.975C643.883 272.654 644.208 272.458 644.53 272.539L649.292 273.735C649.613 273.816 649.808 274.142 649.727 274.463L644.465 295.469C644.385 295.791 644.059 295.986 643.738 295.905L638.976 294.709Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M777.981 124.518L782.938 102.206L788.901 103.534L783.945 125.846L777.981 124.518Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M327.33 329.084L332.287 306.773L338.25 308.101L333.293 330.412L327.33 329.084Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M494.283 285.617L517.077 284.329L517.421 290.435L494.628 291.723L494.283 285.617Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M636.268 72.7666L659.062 71.4787L659.406 77.5843L636.612 78.8721L636.268 72.7666Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M621.872 320.416L644.666 319.128L645.01 325.234L622.216 326.522L621.872 320.416Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M752.85 171.396L769.258 187.288L765.011 191.684L748.602 175.792L752.85 171.396Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M71.5135 35.4699C71.6952 36.0495 71.3731 36.6675 70.7938 36.8498L50.1565 43.3368C49.577 43.519 48.9591 43.1964 48.7773 42.6167L47.3066 37.9268C47.1251 37.3472 47.4481 36.7297 48.0276 36.5475L68.6648 30.0605C69.2442 29.8787 69.861 30.2007 70.0429 30.78L71.5135 35.4699Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M78.9668 320.558C78.4588 320.891 77.7771 320.749 77.4445 320.241L65.5969 302.121C65.2646 301.613 65.4076 300.931 65.9157 300.598L70.0232 297.906C70.5312 297.573 71.2122 297.715 71.5446 298.223L83.3922 316.343C83.7243 316.851 83.582 317.533 83.0743 317.866L78.9668 320.558Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M472.899 317.444C472.391 317.777 471.71 317.635 471.377 317.127L459.53 299.007C459.197 298.499 459.34 297.816 459.848 297.483L463.956 294.791C464.464 294.459 465.145 294.601 465.477 295.109L477.325 313.229C477.657 313.737 477.515 314.419 477.007 314.752L472.899 317.444Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M397.612 11.5837C397.104 11.9167 396.422 11.7749 396.09 11.2667L384.242 -6.85324C383.91 -7.36169 384.053 -8.04391 384.561 -8.37689L388.668 -11.069C389.176 -11.4017 389.857 -11.2597 390.19 -10.7515L402.037 7.36846C402.369 7.87678 402.227 8.55854 401.719 8.89157L397.612 11.5837Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M754.101 112.162C753.499 112.243 752.946 111.822 752.864 111.22L749.951 89.7608C749.869 89.1589 750.29 88.604 750.892 88.5219L755.757 87.8598C756.359 87.7782 756.913 88.2003 756.995 88.8022L759.908 110.262C759.99 110.863 759.568 111.417 758.966 111.499L754.101 112.162Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M780.4 226.926C779.798 227.008 779.244 226.586 779.163 225.985L776.249 204.525C776.168 203.924 776.589 203.369 777.191 203.287L782.056 202.624C782.658 202.543 783.212 202.965 783.294 203.567L786.207 225.026C786.288 225.628 785.867 226.182 785.265 226.264L780.4 226.926Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M183.322 50.2471C182.729 50.115 182.356 49.5275 182.487 48.9346L187.184 27.7938C187.316 27.2011 187.903 26.8275 188.495 26.9594L193.288 28.0267C193.881 28.1589 194.255 28.7464 194.123 29.3392L189.426 50.48C189.295 51.0727 188.707 51.4462 188.115 51.3144L183.322 50.2471Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M-8.58728 235.274C-8.16521 234.837 -7.46968 234.826 -7.03334 235.248L8.51356 250.306C8.94983 250.728 8.96128 251.425 8.53935 251.861L5.12548 255.395C4.70333 255.831 4.00784 255.843 3.57154 255.42L-11.9754 240.363C-12.4114 239.94 -12.4229 239.244 -12.0012 238.807L-8.58728 235.274Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M214.348 292.688L237.126 294.223L236.716 300.324L213.938 298.789L214.348 292.688Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M103.837 5.40747L108.552 27.7713L102.575 29.0346L97.8593 6.67079L103.837 5.40747Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M82.0256 129.344L68.814 147.984L63.832 144.445L77.0436 125.804L82.0256 129.344Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M39.951 193.027L34.1683 193.501C33.8664 193.527 33.59 193.683 33.4158 193.932L30.0646 198.675C29.7697 199.093 29.131 199.021 28.9336 198.549L26.6948 193.19C26.5787 192.911 26.3442 192.697 26.0539 192.606L20.5127 190.881C20.025 190.73 19.8949 190.1 20.2827 189.765L24.6837 185.977C24.9136 185.779 25.0436 185.491 25.039 185.187L24.9647 179.378C24.9577 178.867 25.5174 178.548 25.954 178.813L30.91 181.831C31.1678 181.989 31.4836 182.024 31.7716 181.927L37.2663 180.062C37.7494 179.897 38.2255 180.332 38.107 180.829L36.7717 186.482C36.702 186.777 36.767 187.089 36.9482 187.33L40.4178 191.985C40.7244 192.395 40.4596 192.983 39.9487 193.025L39.951 193.027Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M191.018 86.4216L187.987 86.671C187.829 86.6834 187.683 86.7673 187.592 86.8957L185.836 89.3821C185.681 89.6019 185.348 89.5648 185.244 89.3155L184.07 86.5056C184.009 86.3599 183.885 86.2463 183.735 86.1994L180.832 85.2957C180.576 85.2167 180.509 84.8858 180.711 84.7105L183.017 82.7254C183.138 82.6217 183.207 82.471 183.205 82.3105L183.165 79.2661C183.163 78.997 183.454 78.8315 183.683 78.9698L186.28 80.5525C186.416 80.634 186.581 80.6538 186.731 80.6019L189.612 79.6241C189.866 79.5377 190.115 79.7649 190.053 80.0266L189.353 82.9896C189.316 83.1451 189.35 83.3081 189.444 83.434L191.262 85.8735C191.422 86.0883 191.284 86.397 191.018 86.4167V86.4216Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M91.1382 79.5086L88.1072 79.7579C87.9494 79.7703 87.8039 79.8542 87.7127 79.9826L85.9568 82.469C85.8014 82.6888 85.4685 82.6518 85.3649 82.4024L84.191 79.5925C84.1293 79.4468 84.006 79.3333 83.8556 79.2863L80.9529 78.3826C80.6964 78.3036 80.6298 77.9728 80.8321 77.7974L83.1379 75.8123C83.2588 75.7086 83.3278 75.558 83.3254 75.3975L83.2859 72.353C83.2834 72.0839 83.5744 71.9185 83.8038 72.0567L86.4007 73.6394C86.5363 73.7209 86.7015 73.7407 86.852 73.6888L89.7325 72.711C89.9865 72.6246 90.2355 72.8518 90.1739 73.1135L89.4735 76.0765C89.4365 76.232 89.471 76.395 89.5647 76.5209L91.3823 78.9604C91.5426 79.1752 91.4045 79.4839 91.1382 79.5036V79.5086Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M124.432 286.915L121.401 287.164C121.243 287.177 121.097 287.26 121.006 287.389L119.25 289.875C119.095 290.095 118.762 290.058 118.658 289.809L117.484 286.999C117.423 286.853 117.299 286.74 117.149 286.693L114.246 285.789C113.99 285.71 113.923 285.379 114.126 285.204L116.431 283.219C116.552 283.115 116.621 282.964 116.619 282.804L116.579 279.759C116.577 279.49 116.868 279.325 117.097 279.463L119.694 281.046C119.83 281.127 119.995 281.147 120.145 281.095L123.026 280.117C123.28 280.031 123.529 280.258 123.467 280.52L122.767 283.483C122.73 283.638 122.765 283.801 122.858 283.927L124.676 286.367C124.836 286.581 124.698 286.89 124.432 286.91V286.915Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M30.2236 284.199L27.1927 284.448C27.0349 284.461 26.8894 284.545 26.7981 284.673L25.0422 287.159C24.8868 287.379 24.5539 287.342 24.4503 287.093L23.2764 284.283C23.2148 284.137 23.0915 284.024 22.941 283.977L20.0384 283.073C19.7819 282.994 19.7153 282.663 19.9175 282.488L22.2234 280.503C22.3442 280.399 22.4133 280.248 22.4108 280.088L22.3713 277.043C22.3689 276.774 22.6599 276.609 22.8892 276.747L25.4861 278.33C25.6218 278.411 25.787 278.431 25.9374 278.379L28.8179 277.401C29.0719 277.315 29.321 277.542 29.2593 277.804L28.5589 280.767C28.522 280.922 28.5565 281.085 28.6502 281.211L30.4678 283.651C30.6281 283.866 30.49 284.174 30.2236 284.194V284.199Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M266.601 321.982L263.57 322.232C263.412 322.244 263.266 322.328 263.175 322.456L261.419 324.943C261.264 325.162 260.931 325.125 260.827 324.876L259.653 322.066C259.592 321.92 259.468 321.807 259.318 321.76L256.415 320.856C256.159 320.777 256.092 320.446 256.294 320.271L258.6 318.286C258.721 318.182 258.79 318.032 258.788 317.871L258.748 314.827C258.746 314.558 259.037 314.392 259.266 314.53L261.863 316.113C261.999 316.195 262.164 316.214 262.314 316.162L265.195 315.185C265.449 315.098 265.698 315.325 265.636 315.587L264.936 318.55C264.899 318.706 264.933 318.869 265.027 318.995L266.845 321.434C267.005 321.649 266.867 321.958 266.601 321.977V321.982Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M591.39 339.894L588.359 340.144C588.201 340.156 588.055 340.24 587.964 340.368L586.208 342.855C586.053 343.075 585.72 343.038 585.616 342.788L584.442 339.978C584.381 339.833 584.257 339.719 584.107 339.672L581.204 338.768C580.948 338.689 580.881 338.358 581.084 338.183L583.389 336.198C583.51 336.094 583.579 335.944 583.577 335.783L583.537 332.739C583.535 332.47 583.826 332.304 584.055 332.442L586.652 334.025C586.788 334.107 586.953 334.126 587.103 334.075L589.984 333.097C590.238 333.01 590.487 333.238 590.425 333.499L589.725 336.462C589.688 336.618 589.723 336.781 589.816 336.907L591.634 339.346C591.794 339.561 591.656 339.87 591.39 339.889V339.894Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M726.869 55.1765L723.838 55.4259C723.68 55.4383 723.535 55.5222 723.444 55.6506L721.688 58.137C721.532 58.3568 721.199 58.3197 721.096 58.0703L719.922 55.2605C719.86 55.1148 719.737 55.0012 719.587 54.9543L716.684 54.0506C716.427 53.9716 716.361 53.6407 716.563 53.4654L718.869 51.4802C718.99 51.3765 719.059 51.2259 719.056 51.0654L719.017 48.021C719.014 47.7519 719.305 47.5864 719.535 47.7247L722.132 49.3074C722.267 49.3889 722.432 49.4086 722.583 49.3568L725.463 48.379C725.717 48.2926 725.966 48.5198 725.905 48.7815L725.204 51.7444C725.167 51.9 725.202 52.063 725.296 52.1889L727.113 54.6284C727.274 54.8432 727.135 55.1518 726.869 55.1716V55.1765Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M517.833 56.0984L514.802 56.3478C514.644 56.3601 514.499 56.4441 514.407 56.5725L512.652 59.0589C512.496 59.2786 512.163 59.2416 512.06 58.9922L510.886 56.1824C510.824 56.0367 510.701 55.9231 510.55 55.8762L507.648 54.9725C507.391 54.8935 507.325 54.5626 507.527 54.3873L509.833 52.4021C509.954 52.2984 510.023 52.1478 510.02 51.9873L509.981 48.9429C509.978 48.6737 510.269 48.5083 510.499 48.6466L513.095 50.2293C513.231 50.3108 513.396 50.3305 513.547 50.2787L516.427 49.3009C516.681 49.2145 516.93 49.4416 516.869 49.7034L516.168 52.6663C516.131 52.8219 516.166 52.9848 516.26 53.1108L518.077 55.5503C518.237 55.7651 518.099 56.0737 517.833 56.0935V56.0984Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M431.603 53.8611L428.572 54.1105C428.414 54.1228 428.269 54.2068 428.177 54.3352L426.422 56.8216C426.266 57.0413 425.933 57.0043 425.83 56.7549L424.656 53.945C424.594 53.7994 424.471 53.6858 424.32 53.6389L421.418 52.7352C421.161 52.6562 421.095 52.3253 421.297 52.15L423.603 50.1648C423.724 50.0611 423.793 49.9105 423.79 49.75L423.751 46.7056C423.748 46.4364 424.039 46.271 424.269 46.4093L426.865 47.992C427.001 48.0735 427.166 48.0932 427.317 48.0414L430.197 47.0636C430.451 46.9772 430.7 47.2043 430.639 47.4661L429.938 50.429C429.901 50.5846 429.936 50.7475 430.03 50.8735L431.847 53.313C432.007 53.5278 431.869 53.8364 431.603 53.8562V53.8611Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M746.263 31.3543L743.232 31.6036C743.074 31.616 742.928 31.6999 742.837 31.8283L741.081 34.3147C740.926 34.5345 740.593 34.4975 740.489 34.2481L739.315 31.4382C739.254 31.2925 739.131 31.1789 738.98 31.132L736.077 30.2283C735.821 30.1493 735.754 29.8185 735.957 29.6432L738.262 27.658C738.383 27.5543 738.452 27.4037 738.45 27.2432L738.41 24.1987C738.408 23.9296 738.699 23.7642 738.928 23.9024L741.525 25.4851C741.661 25.5666 741.826 25.5864 741.976 25.5345L744.857 24.5567C745.111 24.4703 745.36 24.6975 745.298 24.9592L744.598 27.9222C744.561 28.0777 744.596 28.2407 744.689 28.3666L746.507 30.8061C746.667 31.0209 746.529 31.3296 746.263 31.3493V31.3543Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M765.354 161.907L762.323 162.156C762.165 162.169 762.02 162.253 761.928 162.381L760.173 164.867C760.017 165.087 759.684 165.05 759.581 164.801L758.407 161.991C758.345 161.845 758.222 161.732 758.071 161.685L755.169 160.781C754.912 160.702 754.846 160.371 755.048 160.196L757.354 158.211C757.475 158.107 757.544 157.956 757.541 157.796L757.502 154.751C757.499 154.482 757.79 154.317 758.02 154.455L760.616 156.038C760.752 156.119 760.917 156.139 761.068 156.087L763.948 155.109C764.202 155.023 764.451 155.25 764.39 155.512L763.689 158.475C763.652 158.63 763.687 158.793 763.781 158.919L765.598 161.359C765.758 161.574 765.62 161.882 765.354 161.902V161.907Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M704.585 276.786L701.554 277.035C701.396 277.048 701.251 277.132 701.159 277.26L699.403 279.746C699.248 279.966 698.915 279.929 698.812 279.68L697.638 276.87C697.576 276.724 697.453 276.611 697.302 276.564L694.4 275.66C694.143 275.581 694.077 275.25 694.279 275.075L696.585 273.09C696.706 272.986 696.775 272.835 696.772 272.675L696.733 269.63C696.73 269.361 697.021 269.196 697.251 269.334L699.847 270.917C699.983 270.998 700.148 271.018 700.299 270.966L703.179 269.988C703.433 269.902 703.682 270.129 703.621 270.391L702.92 273.354C702.883 273.509 702.918 273.672 703.012 273.798L704.829 276.238C704.989 276.453 704.851 276.761 704.585 276.781V276.786Z"
              fill="#FF4040"
              style={{ fill: "#FF4040", fillOpacity: 1 }}
            />
            <path
              d="M187.891 322.075L182.109 322.549C181.807 322.575 181.53 322.731 181.356 322.979L178.005 327.723C177.71 328.141 177.071 328.069 176.874 327.597L174.635 322.238C174.519 321.959 174.285 321.745 173.994 321.654L168.453 319.929C167.965 319.778 167.835 319.148 168.223 318.813L172.624 315.025C172.854 314.827 172.984 314.539 172.979 314.234L172.905 308.426C172.898 307.915 173.458 307.596 173.894 307.861L178.85 310.879C179.108 311.037 179.424 311.072 179.712 310.975L185.207 309.11C185.69 308.945 186.166 309.379 186.047 309.877L184.712 315.53C184.642 315.825 184.707 316.136 184.889 316.378L188.358 321.033C188.665 321.442 188.4 322.031 187.889 322.073L187.891 322.075Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M303.828 307.937L298.046 308.412C297.744 308.437 297.467 308.593 297.293 308.842L293.942 313.585C293.647 314.004 293.008 313.932 292.811 313.46L290.572 308.1C290.456 307.821 290.222 307.607 289.931 307.516L284.39 305.791C283.902 305.64 283.772 305.01 284.16 304.675L288.561 300.887C288.791 300.69 288.921 300.401 288.916 300.097L288.842 294.288C288.835 293.777 289.395 293.458 289.831 293.723L294.787 296.742C295.045 296.9 295.361 296.934 295.649 296.837L301.144 294.972C301.627 294.807 302.103 295.242 301.984 295.739L300.649 301.392C300.579 301.687 300.644 301.999 300.826 302.241L304.295 306.896C304.602 307.305 304.337 307.893 303.826 307.935L303.828 307.937Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M518.148 36.3598L512.731 34.2791C512.448 34.1712 512.132 34.1917 511.867 34.3404L506.79 37.1609C506.343 37.41 505.798 37.0681 505.825 36.5572L506.133 30.757C506.149 30.4552 506.03 30.1607 505.808 29.9531L501.564 25.9952C501.19 25.6475 501.346 25.0233 501.84 24.8898L507.449 23.3857C507.742 23.3073 507.984 23.1039 508.112 22.8275L510.564 17.5617C510.78 17.0978 511.422 17.0535 511.7 17.4817L514.857 22.3507C515.021 22.6049 515.29 22.7733 515.592 22.8102L521.352 23.5132C521.859 23.574 522.099 24.1722 521.777 24.5692L518.122 29.0832C517.931 29.3191 517.854 29.628 517.913 29.9245L519.02 35.6237C519.119 36.1254 518.625 36.5406 518.146 36.3567L518.148 36.3598Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M433.015 82.025L427.71 79.6755C427.432 79.5536 427.115 79.5582 426.843 79.6934L421.631 82.256C421.172 82.4824 420.646 82.1136 420.698 81.6047L421.296 75.8272C421.327 75.5266 421.224 75.2266 421.012 75.0081L416.971 70.8425C416.615 70.4764 416.802 69.8609 417.303 69.7524L422.98 68.5311C423.276 68.4675 423.528 68.2765 423.67 68.0068L426.383 62.8705C426.621 62.418 427.265 62.4059 427.522 62.8475L430.43 67.8685C430.581 68.1307 430.842 68.3124 431.142 68.3644L436.859 69.355C437.362 69.4411 437.572 70.0507 437.23 70.431L433.354 74.7562C433.151 74.9822 433.059 75.2869 433.103 75.5859L433.923 81.3335C433.997 81.8395 433.483 82.2295 433.014 82.0218L433.015 82.025Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M318.758 25.0617L312.975 25.5361C312.674 25.5617 312.397 25.7174 312.223 25.9662L308.872 30.7096C308.577 31.1281 307.938 31.056 307.741 30.584L305.502 25.2245C305.386 24.9455 305.151 24.7316 304.861 24.6409L299.32 22.9156C298.832 22.7645 298.702 22.1343 299.09 21.7995L303.491 18.0118C303.721 17.8142 303.851 17.5258 303.846 17.2212L303.772 11.4129C303.765 10.9014 304.325 10.5829 304.761 10.8479L309.717 13.866C309.975 14.0241 310.291 14.059 310.579 13.9613L316.073 12.0965C316.557 11.9315 317.033 12.3663 316.914 12.8639L315.579 18.5164C315.509 18.8117 315.574 19.1232 315.755 19.3651L319.225 24.0201C319.531 24.4293 319.267 25.0176 318.756 25.0594L318.758 25.0617Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M142.091 64.6692L136.308 65.1435C136.006 65.1691 135.73 65.3249 135.555 65.5737L132.204 70.317C131.909 70.7356 131.271 70.6635 131.073 70.1915L128.835 64.8319C128.718 64.5529 128.484 64.339 128.194 64.2483L122.652 62.523C122.165 62.3719 122.035 61.7418 122.422 61.4069L126.823 57.6192C127.053 57.4216 127.183 57.1333 127.179 56.8287L127.104 51.0204C127.097 50.5088 127.657 50.1903 128.094 50.4553L133.05 53.4734C133.307 53.6315 133.623 53.6664 133.911 53.5688L139.406 51.704C139.889 51.5389 140.365 51.9737 140.247 52.4713L138.911 58.1238C138.842 58.4191 138.907 58.7307 139.088 58.9725L142.557 63.6275C142.864 64.0367 142.599 64.625 142.088 64.6668L142.091 64.6692Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M748.051 308.124L742.268 308.598C741.966 308.624 741.69 308.779 741.515 309.028L738.164 313.772C737.869 314.19 737.231 314.118 737.033 313.646L734.794 308.287C734.678 308.007 734.444 307.794 734.153 307.703L728.612 305.978C728.125 305.826 727.995 305.196 728.382 304.862L732.783 301.074C733.013 300.876 733.143 300.588 733.139 300.283L733.064 294.475C733.057 293.963 733.617 293.645 734.054 293.91L739.01 296.928C739.267 297.086 739.583 297.121 739.871 297.023L745.366 295.159C745.849 294.993 746.325 295.428 746.207 295.926L744.871 301.578C744.802 301.874 744.867 302.185 745.048 302.427L748.517 307.082C748.824 307.491 748.559 308.08 748.048 308.121L748.051 308.124Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M698.931 344.125L693.149 344.599C692.847 344.625 692.57 344.78 692.396 345.029L689.045 349.773C688.75 350.191 688.111 350.119 687.914 349.647L685.675 344.287C685.559 344.008 685.325 343.795 685.034 343.704L679.493 341.979C679.005 341.827 678.875 341.197 679.263 340.863L683.664 337.075C683.894 336.877 684.024 336.589 684.019 336.284L683.945 330.476C683.938 329.964 684.498 329.646 684.934 329.911L689.89 332.929C690.148 333.087 690.464 333.122 690.752 333.024L696.247 331.16C696.73 330.994 697.206 331.429 697.088 331.927L695.752 337.579C695.682 337.875 695.747 338.186 695.929 338.428L699.398 343.083C699.705 343.492 699.44 344.081 698.929 344.122L698.931 344.125Z"
              fill="#FFA600"
              style={{ fill: "#FFA600", fillOpacity: 1 }}
            />
            <path
              d="M399.833 318.282C399.548 318.114 399.451 317.746 399.619 317.461L411.175 297.764C411.342 297.479 411.71 297.384 411.996 297.552L416.467 300.181C416.753 300.349 416.848 300.717 416.681 301.002L405.125 320.699C404.957 320.984 404.59 321.08 404.305 320.912L399.833 318.282Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M339.112 58.5466C339.042 58.223 339.247 57.9037 339.571 57.833L361.864 52.9746C362.188 52.9041 362.507 53.1092 362.577 53.4329L363.68 58.5067C363.75 58.8304 363.545 59.1498 363.222 59.2203L340.929 64.0787C340.605 64.149 340.286 63.9439 340.215 63.6205L339.112 58.5466Z"
              fill="#198428"
              stroke="#198428"
              style={{
                fill: "#198428",
                fillOpacity: 1,
                stroke: "#198428",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M297.932 31.7924L309.79 52.6998L304.238 55.8564L292.38 34.9489L297.932 31.7924Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M469.055 24.6551L461.758 47.561L455.674 45.6181L462.971 22.7123L469.055 24.6551Z"
              fill="#FF00FF"
              stroke="#FF00FF"
              style={{
                fill: "#FF00FF",
                fillOpacity: 1,
                stroke: "#FF00FF",
                strokeOpacity: 1,
              }}
            />
            <path
              d="M80.557 258.897C80.2168 258.394 80.3487 257.71 80.8513 257.369L99.7439 244.562C100.247 244.221 100.93 244.353 101.27 244.856L104.178 249.156C104.518 249.659 104.386 250.343 103.883 250.684L84.9908 263.49C84.488 263.831 83.8049 263.699 83.4646 263.196L80.557 258.897Z"
              fill="#0062FF"
              stroke="#0062FF"
              style={{
                fill: "#0062FF",
                fillOpacity: 1,
                stroke: "#0062FF",
                strokeOpacity: 1,
              }}
              strokeWidth="2"
            />
            <path
              d="M383.781 83.6317L382.225 81.0414C382.143 80.9066 382.006 80.8135 381.851 80.7903L378.869 80.3229C378.606 80.2811 378.493 79.9672 378.667 79.7672L380.646 77.4839C380.748 77.3653 380.794 77.2049 380.769 77.0491L380.293 74.0659C380.251 73.8031 380.513 73.5962 380.759 73.7008L383.539 74.8797C383.683 74.9401 383.848 74.9355 383.99 74.8634L386.677 73.4869C386.914 73.366 387.19 73.552 387.167 73.8171L386.907 76.8282C386.893 76.9863 386.951 77.1398 387.062 77.2514L389.199 79.3859C389.387 79.5742 389.296 79.8951 389.036 79.9556L386.096 80.6368C385.943 80.6717 385.813 80.774 385.741 80.9159L384.375 83.6107C384.255 83.8479 383.92 83.8595 383.783 83.6317H383.781Z"
              fill="#1AFFD1"
              style={{ fill: "#1AFFD1", fillOpacity: 1 }}
            />
            <path
              d="M516.734 271.035L515.178 268.445C515.097 268.31 514.96 268.217 514.805 268.194L511.823 267.726C511.56 267.684 511.446 267.37 511.62 267.171L513.599 264.887C513.701 264.769 513.748 264.608 513.722 264.452L513.246 261.469C513.204 261.206 513.467 261 513.713 261.104L516.493 262.283C516.637 262.343 516.802 262.339 516.943 262.267L519.63 260.89C519.867 260.769 520.144 260.955 520.12 261.22L519.86 264.232C519.846 264.39 519.904 264.543 520.016 264.655L522.153 266.789C522.341 266.978 522.25 267.298 521.99 267.359L519.05 268.04C518.896 268.075 518.766 268.177 518.694 268.319L517.329 271.014C517.208 271.251 516.874 271.263 516.737 271.035H516.734Z"
              fill="#1AFFD1"
              style={{ fill: "#1AFFD1", fillOpacity: 1 }}
            />
            <path
              d="M236.271 61.8115L233.117 56.5636C232.952 56.2892 232.676 56.1032 232.36 56.0544L226.317 55.1057C225.786 55.022 225.553 54.3849 225.906 53.978L229.915 49.3532C230.124 49.1114 230.217 48.7905 230.166 48.4743L229.199 42.4265C229.114 41.894 229.648 41.4755 230.145 41.6871L235.776 44.0751C236.071 44.2006 236.404 44.1867 236.689 44.0425L242.135 41.2546C242.616 41.0081 243.178 41.3872 243.131 41.9243L242.604 48.0255C242.576 48.3441 242.693 48.658 242.918 48.8835L247.249 53.2084C247.63 53.5897 247.444 54.2407 246.919 54.364L240.96 55.7475C240.649 55.8195 240.386 56.0265 240.242 56.3101L237.474 61.772C237.23 62.2533 236.552 62.2766 236.276 61.8162L236.271 61.8115Z"
              fill="#8F33FF"
              style={{ fill: "#8F33FF", fillOpacity: 1 }}
            />
            <path
              d="M808.2 73.5124L802.417 73.9868C802.115 74.0123 801.839 74.1681 801.665 74.4169L798.314 79.1603C798.019 79.5788 797.38 79.5067 797.183 79.0347L794.944 73.6752C794.828 73.3962 794.593 73.1822 794.303 73.0916L788.762 71.3663C788.274 71.2152 788.144 70.585 788.532 70.2502L792.933 66.4625C793.163 66.2648 793.293 65.9765 793.288 65.6719L793.214 59.8636C793.207 59.3521 793.766 59.0335 794.203 59.2986L799.159 62.3167C799.417 62.4748 799.733 62.5097 800.021 62.412L805.515 60.5472C805.998 60.3821 806.474 60.817 806.356 61.3145L805.021 66.967C804.951 67.2623 805.016 67.5739 805.197 67.8157L808.667 72.4707C808.973 72.88 808.709 73.4682 808.198 73.5101L808.2 73.5124Z"
              fill="#8F33FF"
              style={{ fill: "#8F33FF", fillOpacity: 1 }}
            />
            <path
              d="M391.521 286.194L385.739 286.668C385.437 286.694 385.16 286.85 384.986 287.099L381.635 291.842C381.34 292.26 380.701 292.188 380.504 291.716L378.265 286.357C378.149 286.078 377.914 285.864 377.624 285.773L372.083 284.048C371.595 283.897 371.465 283.267 371.853 282.932L376.254 279.144C376.484 278.946 376.614 278.658 376.609 278.354L376.535 272.545C376.528 272.034 377.088 271.715 377.524 271.98L382.48 274.998C382.738 275.156 383.054 275.191 383.342 275.094L388.837 273.229C389.32 273.064 389.796 273.499 389.677 273.996L388.342 279.649C388.272 279.944 388.337 280.256 388.518 280.497L391.988 285.152C392.295 285.562 392.03 286.15 391.519 286.192L391.521 286.194Z"
              fill="#8F33FF"
              style={{ fill: "#8F33FF", fillOpacity: 1 }}
            />
            <path
              d="M559.838 73.24L554.055 73.7143C553.753 73.7399 553.477 73.8957 553.303 74.1445L549.951 78.8878C549.656 79.3063 549.018 79.2343 548.82 78.7623L546.582 73.4027C546.465 73.1237 546.231 72.9098 545.941 72.8191L540.399 71.0938C539.912 70.9427 539.782 70.3126 540.169 69.9777L544.57 66.19C544.8 65.9924 544.93 65.7041 544.926 65.3995L544.851 59.5912C544.844 59.0796 545.404 58.7611 545.841 59.0261L550.797 62.0442C551.054 62.2023 551.37 62.2372 551.658 62.1396L557.153 60.2748C557.636 60.1097 558.112 60.5445 557.994 61.0421L556.658 66.6946C556.589 66.9899 556.654 67.3015 556.835 67.5433L560.305 72.1983C560.611 72.6075 560.346 73.1958 559.835 73.2376L559.838 73.24Z"
              fill="#8F33FF"
              style={{ fill: "#8F33FF", fillOpacity: 1 }}
            />
            <path
              d="M9.30013 27.7068L3.51739 28.1811C3.21548 28.2067 2.93912 28.3625 2.76494 28.6113L-0.58626 33.3546C-0.881203 33.7731 -1.51986 33.7011 -1.71726 33.2291L-3.95604 27.8695C-4.07216 27.5905 -4.30672 27.3766 -4.59702 27.2859L-10.1382 25.5606C-10.6259 25.4095 -10.756 24.7794 -10.3681 24.4445L-5.96722 20.6568C-5.73731 20.4592 -5.60725 20.1709 -5.6119 19.8663L-5.68621 14.058C-5.69318 13.5464 -5.13349 13.2279 -4.69688 13.4929L0.259088 16.511C0.516872 16.6691 0.832716 16.704 1.12069 16.6064L6.61545 14.7416C7.09851 14.5765 7.5746 15.0113 7.45616 15.5089L6.12078 21.1614C6.05111 21.4567 6.11614 21.7683 6.29729 22.0101L9.76693 26.6651C10.0735 27.0743 9.80873 27.6626 9.29781 27.7044L9.30013 27.7068Z"
              fill="#CEA8FB"
              style={{ fill: "#CEA8FB", fillOpacity: 1 }}
            />
            <path
              d="M362.817 278.064L359.963 278.299C359.814 278.311 359.677 278.39 359.591 278.511L357.938 280.852C357.791 281.059 357.478 281.024 357.38 280.789L356.275 278.143C356.217 278.006 356.101 277.899 355.959 277.855L353.226 277.004C352.984 276.93 352.921 276.618 353.112 276.453L355.283 274.584C355.397 274.486 355.462 274.344 355.46 274.193L355.423 271.326C355.42 271.073 355.694 270.917 355.91 271.047L358.356 272.537C358.483 272.614 358.639 272.633 358.781 272.584L361.493 271.663C361.732 271.582 361.967 271.796 361.909 272.042L361.249 274.832C361.215 274.979 361.247 275.132 361.335 275.251L363.047 277.548C363.198 277.75 363.068 278.041 362.817 278.06V278.064Z"
              fill="#1AFFD1"
              style={{ fill: "#1AFFD1", fillOpacity: 1 }}
            />
            <path
              d="M538.817 325.064L535.963 325.299C535.814 325.311 535.677 325.39 535.591 325.511L533.938 327.852C533.791 328.059 533.478 328.024 533.38 327.789L532.275 325.143C532.217 325.006 532.101 324.899 531.959 324.855L529.226 324.004C528.984 323.93 528.921 323.618 529.112 323.453L531.283 321.584C531.397 321.486 531.462 321.344 531.46 321.193L531.423 318.326C531.42 318.073 531.694 317.917 531.91 318.047L534.356 319.537C534.483 319.614 534.639 319.633 534.781 319.584L537.493 318.663C537.732 318.582 537.967 318.796 537.909 319.042L537.249 321.832C537.215 321.979 537.247 322.132 537.335 322.251L539.047 324.548C539.198 324.75 539.068 325.041 538.817 325.06V325.064Z"
              fill="#1AFFD1"
              style={{ fill: "#1AFFD1", fillOpacity: 1 }}
            />
            <path
              d="M280.817 15.0644L277.963 15.2992C277.814 15.3108 277.677 15.3899 277.591 15.5108L275.938 17.8523C275.791 18.0592 275.478 18.0243 275.38 17.7895L274.275 15.1434C274.217 15.0062 274.101 14.8993 273.959 14.8551L271.226 14.0041C270.984 13.9297 270.921 13.6181 271.112 13.453L273.283 11.5836C273.397 11.4859 273.462 11.3441 273.46 11.193L273.423 8.326C273.42 8.07256 273.694 7.91677 273.91 8.04698L276.356 9.53743C276.483 9.61416 276.639 9.63275 276.781 9.58392L279.493 8.66316C279.732 8.58178 279.967 8.79569 279.909 9.04216L279.249 11.8324C279.215 11.9789 279.247 12.1323 279.335 12.2509L281.047 14.5482C281.198 14.7505 281.068 15.0411 280.817 15.0597V15.0644Z"
              fill="#1AFFD1"
              style={{ fill: "#1AFFD1", fillOpacity: 1 }}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M597.467 277.699C598.335 277.728 599.102 278.063 599.724 278.565C600.714 279.363 601.349 280.596 601.444 281.727C602.013 280.739 603.123 279.89 604.367 279.592C605.144 279.407 605.98 279.434 606.777 279.781C607.524 280.106 608.227 280.709 608.81 281.661L608.925 281.856C609.598 283.042 609.601 284.207 609.151 285.313C608.704 286.411 607.813 287.445 606.706 288.393C604.491 290.288 601.365 291.873 599.012 292.948L599.008 292.951C597.345 290.97 595.156 288.189 593.924 285.52C593.308 284.186 592.925 282.866 592.975 281.681C593.026 280.486 593.518 279.433 594.635 278.651L594.823 278.524C595.758 277.915 596.652 277.672 597.467 277.699Z"
              fill="#FF53AC"
              style={{ fill: "#FF53AC", fillOpacity: 1 }}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M739.663 250.425C740.298 249.831 741.077 249.525 741.871 249.441C743.135 249.305 744.456 249.728 745.324 250.461C745.028 249.359 745.211 247.975 745.881 246.884C746.299 246.204 746.909 245.631 747.718 245.313C748.477 245.015 749.4 244.944 750.485 245.205L750.705 245.262C752.019 245.624 752.845 246.446 753.308 247.546C753.769 248.639 753.87 250 753.757 251.454C753.531 254.359 752.442 257.69 751.538 260.115L751.538 260.119C748.961 259.894 745.447 259.476 742.688 258.46C741.309 257.952 740.105 257.29 739.302 256.416C738.494 255.536 738.096 254.443 738.333 253.1L738.377 252.878C738.607 251.785 739.068 250.982 739.663 250.425Z"
              fill="#FF53AC"
              style={{ fill: "#FF53AC", fillOpacity: 1 }}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M272.63 71.1476C273.264 70.5538 274.044 70.2482 274.838 70.1632C276.102 70.028 277.423 70.451 278.291 71.1833C277.994 70.082 278.178 68.6972 278.847 67.6071C279.265 66.9263 279.876 66.354 280.685 66.0359C281.444 65.7376 282.367 65.667 283.452 65.9279L283.672 65.9844C284.985 66.347 285.811 67.169 286.275 68.269C286.736 69.3614 286.837 70.723 286.724 72.1762C286.498 75.082 285.409 78.4129 284.505 80.8372L284.504 80.8419C281.928 80.617 278.413 80.1986 275.655 79.1829C274.276 78.6752 273.072 78.0129 272.269 77.1387C271.46 76.2582 271.063 75.1656 271.3 73.8226L271.343 73.6003C271.574 72.5079 272.034 71.7046 272.63 71.1476Z"
              fill="#FF53AC"
              style={{ fill: "#FF53AC", fillOpacity: 1 }}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M52.5527 96.3317C53.4217 96.3507 54.1925 96.6768 54.82 97.1714C55.8184 97.9583 56.4674 99.1841 56.5759 100.314C57.1339 99.3196 58.2334 98.4578 59.4738 98.1461C60.2487 97.9514 61.0854 97.969 61.8862 98.3069C62.6373 98.624 63.3467 99.2188 63.9406 100.164L64.0581 100.358C64.7441 101.536 64.7602 102.701 64.3229 103.811C63.8886 104.915 63.0095 105.959 61.9129 106.919C59.7201 108.839 56.6125 110.46 54.2714 111.561L54.268 111.565C52.5825 109.603 50.362 106.847 49.0994 104.193C48.4683 102.866 48.0699 101.55 48.1069 100.364C48.1442 99.169 48.6238 98.11 49.7321 97.3153L49.9184 97.1865C50.847 96.5666 51.7376 96.3139 52.5527 96.3317Z"
              fill="#FF53AC"
              style={{ fill: "#FF53AC", fillOpacity: 1 }}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40.347 265.163C40.9817 264.569 41.7609 264.264 42.5553 264.179C43.8194 264.044 45.1403 264.467 46.0078 265.199C45.7116 264.098 45.8955 262.713 46.5646 261.623C46.9826 260.942 47.5933 260.37 48.4021 260.052C49.1609 259.753 50.084 259.683 51.1695 259.944L51.389 260C52.7027 260.363 53.5287 261.185 53.9924 262.285C54.4529 263.377 54.5545 264.739 54.4415 266.192C54.2155 269.098 53.1259 272.429 52.2218 274.853L52.2216 274.857C49.6449 274.633 46.1307 274.214 43.3723 273.199C41.9936 272.691 40.7891 272.029 39.9863 271.154C39.1777 270.274 38.7804 269.181 39.0175 267.838L39.0607 267.616C39.2914 266.523 39.7516 265.72 40.347 265.163Z"
              fill="#FF53AC"
              style={{ fill: "#FF53AC", fillOpacity: 1 }}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M647.29 34.0767C648.122 34.3295 648.776 34.8515 649.247 35.497C649.996 36.5241 650.29 37.8795 650.09 38.9969C650.896 38.1898 652.187 37.6566 653.465 37.6911C654.264 37.7127 655.065 37.9554 655.745 38.4968C656.383 39.0048 656.905 39.7689 657.222 40.8395L657.283 41.0578C657.626 42.3768 657.327 43.5032 656.606 44.4547C655.89 45.3997 654.762 46.1684 653.447 46.7972C650.817 48.0544 647.388 48.7762 644.836 49.2054L644.832 49.2076C643.739 46.8636 642.344 43.6111 641.844 40.7144C641.595 39.2665 641.566 37.8923 641.922 36.7599C642.28 35.6194 643.027 34.729 644.309 34.2628L644.523 34.1891C645.585 33.8427 646.51 33.8396 647.29 34.0767Z"
              fill="#FF53AC"
              style={{ fill: "#FF53AC", fillOpacity: 1 }}
            />
          </g>
          <path
            d="M681.411 15.3469C681.09 15.2662 680.895 14.9405 680.975 14.6192L686.238 -6.38694C686.318 -6.70833 686.644 -6.9041 686.965 -6.82349L691.727 -5.62761C692.049 -5.54675 692.244 -5.2203 692.163 -4.89899L686.901 16.1072C686.82 16.4283 686.495 16.6232 686.173 16.5428L681.411 15.3469Z"
            fill="#198428"
            stroke="#198428"
            style={{
              fill: "#198428",
              fillOpacity: 1,
              stroke: "#198428",
              strokeOpacity: 1,
            }}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3024_5419"
          x="-17.3096"
          y="-12.2495"
          width="830.107"
          height="370.297"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3024_5419"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3024_5419"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3024_5419">
          <rect
            width="800"
            height="340"
            rx="54"
            fill="white"
            style={{ fill: "white", fillOpacity: 1 }}
          />
        </clipPath>
        <clipPath id="clip1_3024_5419">
          <rect
            width="800"
            height="340"
            fill="white"
            style={{ fill: "white", fillOpacity: 1 }}
          />
        </clipPath>
      </defs>
      <text
        x="400"
        y="160"
        fill="white"
        fontSize="61"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line1 || ""}
      </text>
      <text
        x="400"
        y="226"
        fill="white"
        fontSize="50"
        textAnchor="middle"
        fontFamily="'Mori Gothic', Arial"
        fontWeight="600"
      >
        {line2 || ""}
      </text>
    </svg>
  );
}

export default Party;
